import { render } from "./SelectionDatagridSelectionSavedRow.vue?vue&type=template&id=1c6b25a0"
import script from "./SelectionDatagridSelectionSavedRow.vue?vue&type=script&lang=js"
export * from "./SelectionDatagridSelectionSavedRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__